// src/Components/BuildingsTableCorporate/BuildingsTableCorporate.js
import React from 'react';
import { Card, Table, Button, Form } from 'react-bootstrap';
import { BiBuilding } from 'react-icons/bi';
import './BuildingsTableCorporate.css';

const CONTRACT_LABELS = {
  'hvac-maintenance': 'In-Suite',
  'mechanical-room': 'Mechanical Room',
  'dryer-vent': 'Dryer Vents',
  'stack-cleaning': 'Stack Cleaning',
};

function BuildingsTableCorporate({
  // Full pagination & sorting props:
  pageData,
  sortedData,
  startIndex,
  endIndex,
  currentPage,
  totalPages,
  rowsPerPage,
  sortColumn,
  sortDirection,
  handleSort,
  handlePrevPage,
  handleNextPage,
  handleRowsPerPageChange,
}) {
  const noData = pageData.length === 0;

  // Display sort arrow if the user is sorting by that column:
  const getSortArrow = (columnKey) => {
    if (sortColumn === columnKey) {
      return sortDirection === 'asc' ? ' ↑' : ' ↓';
    }
    return '';
  };

  return (
    <div className="buildings-table-corporate-wrapper">
      <Card className="shadow-sm border-0 buildings-table-corporate-card">
        <Card.Body style={{ padding: 0 }}>
          <Table hover responsive className="buildings-table-corporate mb-0 border-0">
            <thead>
              <tr>
                <th>Image</th>
                <th onClick={() => handleSort('name')} className="clickable-th">
                  Building Name {getSortArrow('name')}
                </th>
                <th onClick={() => handleSort('contractValue')} className="clickable-th">
                  Contract Value {getSortArrow('contractValue')}
                </th>
                <th onClick={() => handleSort('contracts')} className="clickable-th">
                  Contracts {getSortArrow('contracts')}
                </th>
                <th onClick={() => handleSort('manager')} className="clickable-th">
                  Manager {getSortArrow('manager')}
                </th>
              </tr>
            </thead>
            <tbody>
              {noData ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center', padding: '2rem' }}>
                    <BiBuilding size={48} color="#1f5eec" />
                    <h4 style={{ marginTop: '1rem', marginBottom: '1rem', fontSize: '1.25rem', color: '#333' }}>
                      No buildings found for your corporate overview.
                    </h4>
                  </td>
                </tr>
              ) : (
                pageData.map((bldg, idx) => (
                  <tr key={idx}>
                    {/* Image */}
                    <td>
                      {bldg.photoUrl ? (
                        <img
                          src={bldg.photoUrl}
                          alt={bldg.name}
                          style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                      ) : (
                        <div
                          style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '4px',
                            backgroundColor: '#eee',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#999'
                          }}
                        >
                          No Image
                        </div>
                      )}
                    </td>

                    {/* Building Name */}
                    <td>{bldg.name || '-'}</td>

                    {/* Contract Value */}
                    <td>
                      {bldg.contractValue
                        ? `$${Number(bldg.contractValue).toLocaleString()}`
                        : '-'
                      }
                    </td>

                    {/* Contracts */}
                    <td>
                      {Array.isArray(bldg.contracts) && bldg.contracts.length > 0
                        ? bldg.contracts.map((contract, i) => (
                            <span key={contract} style={{
                              display: 'inline-block',
                              background: '#f1f3f7',
                              color: '#333',
                              borderRadius: '12px',
                              padding: '2px 10px',
                              marginRight: 6,
                              marginBottom: 2,
                              fontSize: '0.95em',
                              fontWeight: 500,
                            }}>
                              {CONTRACT_LABELS[contract] || contract}
                            </span>
                          ))
                        : <span style={{ color: '#aaa' }}>None</span>}
                    </td>

                    {/* Manager */}
                    <td>{bldg.manager || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>

            {/* Pagination Footer */}
            <tfoot>
              <tr>
                <td colSpan={5}>
                  <div className="buildings-pagination d-flex justify-content-between align-items-center mt-3">
                    <div className="d-flex align-items-center">
                      <span className="me-2">Rows per page:</span>
                      <Form.Select
                        value={rowsPerPage}
                        onChange={handleRowsPerPageChange}
                        className="rows-per-page-select"
                        style={{ width: 'auto' }}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                      </Form.Select>
                      <span className="ms-3">
                        Showing {startIndex + 1} to {Math.min(endIndex, sortedData.length)} of {sortedData.length}
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="me-3">
                        Page {currentPage} of {Math.max(totalPages, 1)}
                      </span>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="me-2"
                        onClick={handlePrevPage}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleNextPage}
                        disabled={currentPage >= totalPages}
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
}

export default BuildingsTableCorporate;
